import { ContentPage } from '../components/content-page';
import { CourseManagementDataContext, CourseManagementDataProvider } from '../providers/course-management-provider';
import { useContext } from 'react';
import { SelectedDetailsHeading } from '../components/selected-details-heading';
import { CourseList } from '../components/admin-courses/course-list';
import AdminDetailsSelector from '../components/admin-courses/course-details-selector';
import { useLocation } from 'react-router-dom';

export default function AdminCoursesPage() {
    const { search } = useLocation();
    return (
        <CourseManagementDataProvider>
            <div style={{ flex: 1, display: 'flex', minHeight: 0, width: '100%', minWidth: '0'/*, backgroundColor: 'blue'*/ }}>
                <ContentPage
                    pageId="courses"
                    pageTitle="Course management"
                    leftPanelTitle="Courses"
                    rightPanelTitle="Selected course details"
                    rightPanelHeading={<CourseDetailsHeading />}
                    mobileTabs
                    mobileBackLabel="Back to courses"
                    mobileRightPanelTitle="Details"
                    initialMobilePanel={new URLSearchParams(search).has('course') ? 'right' : 'left'}
                    leftContent={<CourseList />}
                    rightContent={<AdminDetailsSelector />}
                />
            </div>
        </CourseManagementDataProvider>
    );
}

function CourseDetailsHeading() {
    const ctx = useContext(CourseManagementDataContext)!;
    if (ctx.mode === 'create') return <SelectedDetailsHeading label="New course" />;
    const course = ctx.selectedCourseFull?.course_key === ctx.selectedCourseKey ? ctx.selectedCourseFull
        : ctx.allCourses.find(item => item.course_key === ctx.selectedCourseKey);
    return <SelectedDetailsHeading label="Course details" names={course ? [course.name] : []} />;
}
